import React, { Children, useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Drp_SubLevel from '../AccountSubLevelGroup/Drp_SubLevel.js';



const AccountDetailIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const SubL1Ref = React.useRef();
    const SubL2Ref = React.useRef();
    const SubL3Ref = React.useRef();


    const [SearchTitle, setSearchTitle] = useState("");
    const [Header, SetHeader] = useState("");
    const [IsActiveSearch, setIsActiveSearch] = useState(-1);
    const [Title, setTitle] = useState("");
    const [Code, setCode] = useState("");
    const [SystemCode, setSystemCode] = useState("");
    const [PreCode, setPreCode] = useState("");
    const [PreSystemCode, setPreSystemCode] = useState("");
    const [IsActive, setIsActive] = useState(true);
    const [List, setList] = useState([]);
    const [TreeList, setTreeList] = useState([]);
    const [Sub_Acc_L1, setSub_Acc_L1] = useState(-1);
    const [Sub_Acc_L2, setSub_Acc_L2] = useState(-1);
    const [Sub_Acc_L3, setSub_Acc_L3] = useState(-1);
    const [Sub_Acc_LC1, setSub_Acc_LC1] = useState("");
    const [Sub_Acc_LC2, setSub_Acc_LC2] = useState("");
    const [Sub_Acc_LC3, setSub_Acc_LC3] = useState("");
    const [ACC_GLId, setACC_GLId] = useState(General.GuidEmpty());
    const [ACC_GId, setACC_GId] = useState(General.GuidEmpty());
    const [ACC_Id, setACC_Id] = useState(General.GuidEmpty());
    const [CreateModal, setCreateModal] = useState(false);
    const [CreateGeneralLedgerModal, setCreateGeneralLedgerModal] = useState(false);
    const [CreateControlModal, setCreateControlModal] = useState(false);

    const TreeHeaders = ['گروه حساب', ' حساب کل', 'حساب معین'];

    //#endregion



    //#region Methods

    const Reset = () => {

        setTitle("");
        setCode("");
        setSystemCode("");
        setPreCode("");
        setPreSystemCode("");
        setIsActive(true);
        setSub_Acc_L1(-1);
        setSub_Acc_L2(-1);
        setSub_Acc_L3(-1);
        setSub_Acc_LC1("");
        setSub_Acc_LC2("");
        setSub_Acc_LC3("");
        setACC_GLId(General.GuidEmpty());
        setACC_GId(General.GuidEmpty());
        setACC_Id(General.GuidEmpty());

    }
    const ResetForSave = () => {

        setTitle("");
        setCode("");
        setSystemCode("");
        // setPreCode("");
        // setPreSystemCode("");
        setIsActive(true);
        setSub_Acc_L1(-1);
        setSub_Acc_L2(-1);
        setSub_Acc_L3(-1);
        setSub_Acc_LC1("");
        setSub_Acc_LC2("");
        setSub_Acc_LC3("");
        // setACC_GLId(General.GuidEmpty());
        // setACC_GId(General.GuidEmpty());
        // setACC_Id(General.GuidEmpty());

    }
    const ShowNew = () => {
        Reset();
        GetMaxCode();
        setCreateModal(true);
    }

    const Edit = (id) => {
        Reset();
        trackPromise(
            fetch(General.ApiRoute() + '/Account_Group/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setCreateModal(true);
                    setACC_GId(result.id);
                    setTitle(result.title);
                    setCode(result.code);
                    setSystemCode(result.systemCode);
                    setIsActive(result.isActive);
                })
        )
    }

    const GetMaxCode = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/Account_Group/GetMaxCode', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setSystemCode(result.split("|")[1]);
                    setCode(result.split("|")[0]);
                })
        )
    }

    const Edit_GeneralLedger = (id) => {
        Reset();
        trackPromise(
            fetch(General.ApiRoute() + '/Account_GeneralLedger/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setCreateGeneralLedgerModal(true);
                    setACC_GLId(result.id);
                    setACC_GId(result.acc_GId)
                    setTitle(result.title);
                    setCode(result.code);
                    setSystemCode(result.systemCode);
                    setPreCode(result.preCode);
                    setPreSystemCode(result.preSystemCode);
                    setIsActive(result.isActive);
                })
        )
    }

    const GetMaxCode_GeneralLedger = (preSystemCode, preCode, acc_GId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/Account_GeneralLedger/GetMaxCode', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Acc_GId': acc_GId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setPreSystemCode(preSystemCode);
                    setPreCode(preCode);
                    setSystemCode(result.split("|")[1]);
                    setCode(result.split("|")[0]);
                })
        )
    }

    const ShowNew_GeneralLedger = (title, acc_GId, preCode, preSystemCode) => {
        Reset();
        setACC_GId(acc_GId)
        SetHeader(title)
        GetMaxCode_GeneralLedger(preSystemCode, preCode, acc_GId);
        setCreateGeneralLedgerModal(true);
    }

    const Edit_Control = (id) => {
        Reset();
        trackPromise(
            fetch(General.ApiRoute() + '/Account_Control/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setCreateControlModal(true);
                    setACC_Id(result.id);
                    setACC_GLId(result.acc_GLId)
                    setTitle(result.title);
                    setCode(result.code);
                    setSystemCode(result.systemCode);
                    setPreCode(result.preCode);
                    setPreSystemCode(result.preSystemCode);
                    setIsActive(result.isActive);
                    setSub_Acc_L1(result.sub_Acc_L1);
                    setSub_Acc_L2(result.sub_Acc_L2);
                    setSub_Acc_L3(result.sub_Acc_L3);
                    setSub_Acc_LC1(result.sub_Acc_LC1);
                    setSub_Acc_LC2(result.sub_Acc_LC2);
                    setSub_Acc_LC3(result.sub_Acc_LC3);

                    setTimeout(() => {
                        SubL1Ref.current.Bind(result.sub_Acc_L1)
                        SubL2Ref.current.Bind(result.sub_Acc_L2)
                        SubL3Ref.current.Bind(result.sub_Acc_L3)

                    }, 1000);

                })
        )
    }

    const GetMaxCode_Control = (preSystemCode, preCode, acc_GLId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/Account_Control/GetMaxCode', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Acc_GLId': acc_GLId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setPreSystemCode(preSystemCode);
                    setPreCode(preCode);
                    setSystemCode(result.split("|")[1]);
                    setCode(result.split("|")[0]);
                })
        )
    }

    const ShowNew_Control = (title, acc_GLId, preCode, preSystemCode) => {
        setCreateControlModal(true);
        Reset();
        setACC_GLId(acc_GLId);
        SetHeader(title)
        GetMaxCode_Control(preSystemCode, preCode, acc_GLId);

        setTimeout(() => {
            SubL1Ref.current.Bind(-1)
            SubL2Ref.current.Bind(-1)
            SubL3Ref.current.Bind(-1)
        }, 1000);



    }

    const Search = () => {
        var RequestOptions = {
            data: {
                'Title': SearchTitle,
                'IsActive': IsActiveSearch,
            },
            url: General.ApiRoute() + "/Account_Group/Search",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(result => {
                    var tmp = []
                    console.dir(result.data)

                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            title: result.data[i].title,
                            id: result.data[i].id,
                            isActive: result.data[i].isActive,
                            preCode: result.data[i].preCode,
                            preSystemCode: result.data[i].preSystemCode,
                            acc_GLId: result.data[i].acc_GLId,
                            acc_GId: result.data[i].acc_GId,
                            code: result.data[i].code,
                            systemCode: result.data[i].systemCode,
                            sub_Acc_LC1: result.data[i].sub_Acc_LC1,
                            sub_Acc_LC2: result.data[i].sub_Acc_LC2,
                            sub_Acc_LC3: result.data[i].sub_Acc_LC3,
                            children: result.data[i].children,
                        })
                    }
                    setList(tmp)
                    console.dir(tmp)

                })
                .catch((error) => {
                    console.dir(error)
                })
        )

    }

    const GetTree = () => {
        var tmp = [];
        var RequestOptions = {

            url: General.ApiRoute() + "/Account_Group/GetTree",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                'IsActive': -1
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            label: result.data[i].label,
                            value: result.data[i].value,
                            children: result.data[i].children,
                        })
                    }
                    setTreeList(tmp)

                })
                .catch((error) => {
                    console.dir(error)
                })
        )

    }
    const Column = ({ header, children }) => {
        return (
            <div>
                <div
                    style={{
                        background: '#154c94',
                        padding: '4px 10px',
                        color: ' #fff',
                        textAlign: 'center'
                    }}
                >
                    {header}
                </div>
                {children}
            </div>
        );
    };

    const Save = () => {

        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (Code == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن کد اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": ACC_Id,
                "Code": Code,
                "Title": Title,
                "IsActive": IsActive == true ? 1 : 0,
            },
            url: General.ApiRoute() + "/Account_Group/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        GetTree();
                        if (ACC_Id != General.GuidEmpty()) {
                            setCreateModal(false);
                            Reset()

                        }
                        else {
                            GetMaxCode();
                            ResetForSave();
                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const Save_GeneralLedger = () => {


        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (ACC_GId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب گروه حساب اجباری می باشد")), 'topCenter')
            return;
        }
        if (Code == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن کد اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": ACC_GLId,
                "Acc_GId": ACC_GId,
                "Code": Code,
                "Title": Title,
                "IsActive": IsActive == true ? 1 : 0,
            },
            url: General.ApiRoute() + "/Account_GeneralLedger/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        GetTree();
                        if (ACC_GLId != General.GuidEmpty()) {
                            setCreateGeneralLedgerModal(false);
                            Reset()

                        }
                        else {
                            GetMaxCode_GeneralLedger(PreSystemCode, PreCode, ACC_GId);
                            ResetForSave()
                        }
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const Save_Control = () => {


        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (ACC_GLId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب حساب کل اجباری می باشد")), 'topCenter')
            return;
        }
        if (Code == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن کد اجباری می باشد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": ACC_Id,
                "ACC_GLId": ACC_GLId,
                "Code": Code,
                "Title": Title,
                "Sub_Acc_L1": Sub_Acc_L1,
                "Sub_Acc_L2": Sub_Acc_L2,
                "Sub_Acc_L3": Sub_Acc_L3,
                "IsActive": IsActive == true ? 1 : 0,
            },
            url: General.ApiRoute() + "/Account_Control/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        Search();
                        GetTree();


                        if (ACC_Id != General.GuidEmpty()) {
                            setCreateControlModal(false);
                            Reset()

                        }
                        else {
                            GetMaxCode_Control(PreSystemCode, PreCode, ACC_GLId);
                            ResetForSave()
                        }

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 29);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        GetTree();
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    useEffect(() => {
        CheckPermission();
        document.title = "تعریف گروه حساب/حساب کل/حساب معین";
    }, [])
    //#endregion



    return (

        <Layout title=" تعریف گروه حساب/حساب کل/حساب معین ">
            <div className="h-100 p-1"  >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={()=>(Search(), GetTree())}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  حساب کل جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />


                    <rsuite.Row className="p-1 mb-5 pb-5" >


                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-3'>
                            <rsuite.Tabs defaultActiveKey='1' appearance="subtle">
                                <rsuite.Tabs.Tab eventKey="1" title="تعریف حساب">

                                    <rsuite.Row className='p-1'>
                                        <rsuite.Col xxl={16} xl={16} lg={16} md={16} sm={24} xs={24}>
                                            <label>جستجو   </label>
                                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                                        </rsuite.Col>

                                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={14} xs={24}>
                                            <label> وضعیت فعال بودن   </label>
                                            <select className="rs-input" onChange={(e) => setIsActiveSearch(e.target.value)} value={IsActiveSearch}>
                                                <option value="-1">انتخاب نمایید</option>
                                                <option value="0">غیر فعال </option>
                                                <option value="1">فعال </option>


                                            </select>
                                        </rsuite.Col>




                                    </rsuite.Row>

                                    <div className="h-90 p-1">
                                        <div className="h-100-y">

                                            <rsuite.Panel className="bg-white mt-2">

                                                <rsuite.Table
                                                    isTree
                                                    rowKey='id'
                                                    height={550}
                                                    data={List}
                                                    wordWrap="break-word"


                                                >
                                                    <rsuite.Table.Column flexGrow={1} align="center" fixed >
                                                        <rsuite.Table.HeaderCell>کد</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey="code" />

                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} align="center" fixed >
                                                        <rsuite.Table.HeaderCell> کد سیستمی</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey="systemCode" />

                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column flexGrow={5} fixed resizable>
                                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>

                                                            {(rowData) => {
                                                                return <>
                                                                    {rowData.title}
                                                                    {rowData.acc_GLId != General.GuidEmpty() ?
                                                                        <small>
                                                                            <br />
                                                                            <b>تفصیلی سطح 1 : </b> {rowData.sub_Acc_LC1} &nbsp;&nbsp;&nbsp;&nbsp;  -
                                                                            <b>تفصیلی سطح 2 : </b> {rowData.sub_Acc_LC2} &nbsp;&nbsp;&nbsp;&nbsp;  -
                                                                            <b>تفصیلی سطح 3 : </b> {rowData.sub_Acc_LC3}
                                                                        </small>
                                                                        :
                                                                        ""
                                                                    }
                                                                </>

                                                            }}
                                                        </rsuite.Table.Cell>

                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return <>
                                                                    {rowData.isActive == 1 ?
                                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                                        :
                                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                                    }
                                                                </>
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>

                                                    <rsuite.Table.Column fixed="right" flexGrow={1} >
                                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return <>
                                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                                        <rsuite.Popover full className='PopoverMenu'>
                                                                            <rsuite.Dropdown.Menu  >
                                                                                <rsuite.Dropdown.Item onClick={() =>
                                                                                (rowData.acc_GId == General.GuidEmpty() && rowData.acc_GLId == General.GuidEmpty() ? Edit(rowData.id) :
                                                                                    rowData.acc_GId != General.GuidEmpty() ? Edit_GeneralLedger(rowData.id) : Edit_Control(rowData.id))}>ویرایش</rsuite.Dropdown.Item>

                                                                                {rowData.acc_GId != General.GuidEmpty() || (rowData.acc_GId == General.GuidEmpty() && rowData.acc_GLId == General.GuidEmpty()) ?
                                                                                    <rsuite.Dropdown.Item
                                                                                        onClick={() => (rowData.acc_GId == General.GuidEmpty() && rowData.acc_GLId == General.GuidEmpty() ? ShowNew_GeneralLedger(rowData.title, rowData.id, rowData.code, rowData.systemCode) :
                                                                                            ShowNew_Control(rowData.title, rowData.id, rowData.code, rowData.systemCode))
                                                                                        }>{rowData.acc_GId != General.GuidEmpty() ? <>حساب معین جدید</> : <>حساب کل جدید</>}</rsuite.Dropdown.Item>
                                                                                    :
                                                                                    <></>
                                                                                }

                                                                            </rsuite.Dropdown.Menu>
                                                                        </rsuite.Popover>
                                                                    }>
                                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                                    </rsuite.Whisper>
                                                                </>
                                                            }}
                                                        </rsuite.Table.Cell>

                                                    </rsuite.Table.Column>
                                                </rsuite.Table>
                                            </rsuite.Panel>

                                        </div>
                                    </div>
                                </rsuite.Tabs.Tab>
                                <rsuite.Tabs.Tab eventKey="2" title=" درخت حساب ها ">
                                    <rsuite.CascadeTree
                                        data={TreeList}
                                        columnWidth={300}
                                        columnHeight={500}
                                        renderTreeNode={(label, node) => {
                                            return (
                                                <>
                                                    {label}
                                                </>
                                            );
                                        }}
                                        renderColumn={(childNodes, { layer }) => {
                                            return <Column header={TreeHeaders[layer]}> {childNodes}</Column>;
                                        }}
                                    />
                                </rsuite.Tabs.Tab>

                            </rsuite.Tabs>





                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />

                    {/* <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن محصول جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+p :</b> پرینت
                            </small>
                        </rsuite.Col>
                    </rsuite.Row> */}
                </rsuite.Panel >
            </div >


            <Modal show={CreateModal} onHide={() => setCreateModal(false)} size="xs" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'><b>تعریف حساب کل</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Code == "" ? 'text-danger' : 'hide'} />  <label>کد حساب</label>
                                <rsuite.Input value={Code} onChange={(e) => (setCode(e))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>کد سیستمی حساب</label>
                                <rsuite.Input value={SystemCode} readOnly disabled />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>

                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setCreateModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Modal show={CreateGeneralLedgerModal} onHide={() => setCreateGeneralLedgerModal(false)} size="xs" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'> تعریف حساب کل <b>{Header}</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Code == "" ? 'text-danger' : 'hide'} />  <label>کد حساب</label>
                                <rsuite.InputGroup >
                                    <rsuite.InputGroup.Addon>{PreCode}</rsuite.InputGroup.Addon>
                                    <rsuite.Input value={Code} onChange={(e) => setCode(e)} />
                                </rsuite.InputGroup>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>کد سیستمی حساب</label>
                                <rsuite.InputGroup >
                                    <rsuite.InputGroup.Addon>{PreSystemCode}</rsuite.InputGroup.Addon>
                                    <rsuite.Input value={SystemCode} readOnly disabled />
                                </rsuite.InputGroup>
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>

                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save_GeneralLedger}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setCreateGeneralLedgerModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Modal show={CreateControlModal} onHide={() => setCreateControlModal(false)} size="xs" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'> تعریف حساب معین <b>{Header}</b> </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>

                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Code == "" ? 'text-danger' : 'hide'} />  <label>کد حساب</label>
                                <rsuite.InputGroup >
                                    <rsuite.InputGroup.Addon>{PreCode}</rsuite.InputGroup.Addon>
                                    <rsuite.Input value={Code} onChange={(e) => setCode(e)} />
                                </rsuite.InputGroup>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>کد سیستمی حساب</label>
                                <rsuite.InputGroup >
                                    <rsuite.InputGroup.Addon>{PreSystemCode}</rsuite.InputGroup.Addon>
                                    <rsuite.Input value={SystemCode} readOnly disabled />
                                </rsuite.InputGroup>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>گروه حساب تفصیلی سطح 1</label>
                                <Drp_SubLevel value={Sub_Acc_L1} onChange={(value, title) => (setSub_Acc_L1(value), setSub_Acc_LC1(title))} ref={SubL1Ref} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>گروه حساب تفصیلی سطح 2</label>
                                <Drp_SubLevel value={Sub_Acc_L2} onChange={(value, title) => (setSub_Acc_L2(value), setSub_Acc_LC2(title))} ref={SubL2Ref} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label>گروه حساب تفصیلی سطح 3</label>
                                <Drp_SubLevel value={Sub_Acc_L3} onChange={(value, title) => (setSub_Acc_L3(value), setSub_Acc_LC3(title))} ref={SubL3Ref} />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;   فعال می باشد
                            </rsuite.Col>

                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save_Control}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setCreateControlModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

        </Layout >



    )
}

export default AccountDetailIndex;